import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect, ElementRef, inject, PLATFORM_ID, signal, viewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { injectQueryParams } from 'ngxtension/inject-query-params';
import { UserService } from 'src/app/@domain/user/application/user.service';
import { onFirstClick } from '../../../@common/DOM/close-on-first-click.function';
import { ImageDirective } from '../../../@common/DOM/image.directive';
import { AdminRoute } from '../../../routing/types/admin-route';
import { AppRoute } from '../../../routing/types/app-route';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: [ './header.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        RouterLink,
        ImageDirective,
        FormsModule,
        FaIconComponent,
        CommonModule
    ]
})
export class HeaderComponent {
    private userService = inject(UserService);
    private router = inject(Router);
    private route = inject(ActivatedRoute);

    public searchBar = viewChild.required<ElementRef<HTMLInputElement>>('searchBar');
    public query = injectQueryParams('query');
    public userProfile = this.userService.user;
    public isAuthenticated = this.userService.isAuthenticated;
    public isAdmin = this.userService.isAdmin;
    public isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
    public isMenuOpen = signal(false);
    public isSignedInMenuOpen = signal(false);
    public onAdminRoute = this.router.url.includes(AdminRoute.Admin);
    public faSearch = faSearch;
    public AppRoutes = AppRoute;
    public AdminRoute = AdminRoute;

    constructor() {
        effect(() => {
            if (this.isSignedInMenuOpen()) {
                onFirstClick(() => this.isSignedInMenuOpen.set(false))
            }
        })
    }

    public onLogout() {
        this.userService.logout();
    }

    public onSubmit(): void {
        const query = this.searchBar().nativeElement.value;

        if (!query) return;
        this.searchBar().nativeElement.blur();

        this.router.navigate([ '/' + AppRoute.Search ], {
            queryParams: { query, tab: this.route.snapshot.queryParams.tab },
            relativeTo: this.route
        });
    }

    public toggleProfileMenu(): void {
        this.isSignedInMenuOpen.set(!this.isSignedInMenuOpen());
    }
}
